import { FC, ReactNode } from 'react'
import Tabs from '../../../__legacy__/components/platform/new-explore/components/Tabs'

export const Tab: FC<{ value: string; icon: ReactNode; label: string }> = ({
  label,
  value,
  icon
}) => (
  <Tabs.Trigger value={value}>
    <Tabs.Icon>{icon}</Tabs.Icon>
    {label}
  </Tabs.Trigger>
)
